@if ((cartBenefits()?.length ?? 0) > 0) {
  <section
    class="employee-basket-card employee-basket-cart"
    [class.employee-basket-cart--no-net-saving]="!showNetSavingColumn()"
  >
    <mat-expansion-panel
      class="employee-basket-cart__panel"
      [expanded]="expanded()"
      (expandedChange)="expanded.set($event)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="employee-basket-cart__header">
          <mat-icon class="employee-basket-cart__icon" [style.color]="wls.warnColor">
            shopping_cart
          </mat-icon>
          <span class="employee-basket-cart__title">
            {{ 'employee.basket.cart' | translate }}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="employee-basket-card__columns">
        <span class="employee-basket-card__column-label"></span>
        <span class="employee-basket-card__column-amount">
          {{ 'employee.basket.amount' | translate }}
        </span>
        <span
          class="employee-basket-card__column-net-saving"
          [class.employee-basket-card__column-net-saving--actions-only]="!showNetSavingColumn()"
          [style.color]="wls.warnColor"
        >
          @if (showNetSavingColumn()) {
            {{ 'employee.basket.net-saving' | translate }}
          }
        </span>
      </div>

      @for (benefit of cartBenefits(); track benefit.id) {
        <flexyoo-employee-basket-benefit-row
          [benefit]="benefit"
          [isSelected]="benefit.id === selectedBenefitId()"
          [showConfirmIcon]="true"
          [showNetSavingColumn]="showNetSavingColumn()"
          [showRemoveButton]="true"
          (remove)="onRemoveBenefit(benefit)"
          (sign)="signBenefit.emit($event)"
        />
      }

      <!-- The mockup opens the report from a "Cart simulation" popup that this UI
           does not have, so the entry point lives in the cart panel instead. -->
      @if (isCartMode()) {
        <button
          class="employee-basket-cart__report-button"
          matButton="outlined"
          type="button"
          (click)="onOpenFinancialImpactReport()"
        >
          {{ 'employee.financial-impact-report.open' | translate }}
        </button>
      }
    </mat-expansion-panel>
  </section>
}
